export default __webpack_public_path__ + "static/media/wild-rift-avatar.f9cff2ab.png";